module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "流水号"
    },
    model: {
      value: (_vm.params.channelOrderNo),
      callback: function($$v) {
        _vm.$set(_vm.params, "channelOrderNo", $$v)
      },
      expression: "params.channelOrderNo"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.searchData
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "用户ID"
    },
    model: {
      value: (_vm.params.user_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "user_id", $$v)
      },
      expression: "params.user_id"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.searchData
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "门店号"
    },
    model: {
      value: (_vm.params.channelStoreNo),
      callback: function($$v) {
        _vm.$set(_vm.params, "channelStoreNo", $$v)
      },
      expression: "params.channelStoreNo"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.searchData
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "placeholder": "通过",
      "clearable": ""
    },
    on: {
      "change": _vm.searchData
    },
    model: {
      value: (_vm.params.is_pass),
      callback: function($$v) {
        _vm.$set(_vm.params, "is_pass", $$v)
      },
      expression: "params.is_pass"
    }
  }, _vm._l((_vm.passList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "placeholder": "返现",
      "clearable": ""
    },
    on: {
      "change": _vm.searchData
    },
    model: {
      value: (_vm.params.is_send),
      callback: function($$v) {
        _vm.$set(_vm.params, "is_send", $$v)
      },
      expression: "params.is_send"
    }
  }, _vm._l((_vm.sendList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.exportloading),
      expression: "exportloading"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.userList,
      "height": _vm.wheight - 130
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "members_id",
      "label": "门店号",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.channelStoreNo) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "channelOrderNo",
      "label": "订单流水号",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.channelOrderNo) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_id",
      "label": "用户ID",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.user_id) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userNo",
      "label": "方伞权益编号",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.userNo) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderTime",
      "label": "下单时间",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.orderTime) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderAmt",
      "label": "实收金额",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.orderAmt) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "benefitAmt",
      "label": "试算金额",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.benefitAmt) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "benefitAmt",
      "label": "返现金额",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.benefitAmt) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "is_pass",
      "label": "通过",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.is_pass) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "is_send",
      "label": "返现",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.is_send) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "employee",
      "label": "推荐手机号",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.employee) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cal_msg",
      "label": "试算结果",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.cal_msg) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ordersync_msg",
      "label": "上传发票结果",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.ordersync_msg) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "allOrderRealAmt",
      "label": "方伞总补贴",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.allOrderRealAmt) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "employeeReward",
      "label": "员工奖励",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.employeeReward) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "distributionName",
      "label": "门店名",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.distributionName) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "380"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.toEdit(scope.row)
            }
          }
        }, [_vm._v("查看图片")]), _vm._v(" "), (scope.row.is_trial == '1' && scope.row.is_send == '未返现') ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.isSendAction(scope.$index, scope.row)
            }
          }
        }, [_vm._v("返现\n        ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.editAction(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), (scope.row.is_send_employee == '0') ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.isSendEmployee(scope.$index, scope.row)
            }
          }
        }, [_vm._v("给员工返现\n        ")]) : _vm._e(), _vm._v(" "), (scope.row.is_trial != '1') ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.isTrial(scope.$index, scope.row)
            }
          }
        }, [_vm._v("试算")]) : _vm._e(), _vm._v(" "), (scope.row.is_pass != '已通过') ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.isPassAction(scope.$index, scope.row)
            }
          }
        }, [_vm._v("上传发票\n        ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.page_size) ? _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.page_size
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "审核",
      "visible": _vm.editDialog,
      "width": "50%",
      "close-on-click-modal": false,
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.formdata
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "资料",
      "readonly": "",
      "label-width": "15%"
    }
  }, [_c('div', {
    staticClass: "demo-image__preview"
  }, [_c('el-image', {
    staticStyle: {
      "width": "200px",
      "height": "150px"
    },
    attrs: {
      "src": _vm.form.img,
      "preview-src-list": [_vm.form.img, _vm.form.img]
    }
  }), _vm._v(" "), _c('el-image', {
    staticStyle: {
      "width": "200px",
      "height": "150px"
    },
    attrs: {
      "src": _vm.form.front,
      "preview-src-list": [_vm.form.front, _vm.form.front]
    }
  }), _vm._v(" "), _c('el-image', {
    staticStyle: {
      "width": "200px",
      "height": "150px"
    },
    attrs: {
      "src": _vm.form.backend,
      "preview-src-list": [_vm.form.backend, _vm.form.backend]
    }
  }), _vm._v(" "), _c('el-image', {
    staticStyle: {
      "width": "200px",
      "height": "150px"
    },
    attrs: {
      "src": _vm.form.drug,
      "preview-src-list": [_vm.form.drug, _vm.form.drug]
    }
  }), _vm._v(" "), _c('el-image', {
    staticStyle: {
      "width": "200px",
      "height": "150px"
    },
    attrs: {
      "src": _vm.form.dzqm,
      "preview-src-list": [_vm.form.dzqm, _vm.form.dzqm]
    }
  })], 1)])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改信息",
      "width": "40%",
      "visible": _vm.employeeDialog,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.employeeDialog = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.form,
        "label-width": "100px"
      }
    }, [_c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "推荐人",
        "prop": "employee"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入推荐人手机号"
      },
      model: {
        value: (_vm.form.employee),
        callback: function($$v) {
          _vm.$set(_vm.form, "employee", $$v)
        },
        expression: "form.employee"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "下单时间",
        "prop": "orderTime"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入下单时间"
      },
      model: {
        value: (_vm.form.orderTime),
        callback: function($$v) {
          _vm.$set(_vm.form, "orderTime", $$v)
        },
        expression: "form.orderTime"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-center"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.saveEmployeeData
      }
    }, [_vm._v("确定保存")])], 1)], 1)]
  ], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改信息",
      "width": "40%",
      "visible": _vm.passDialog,
      "before-close": _vm.invoiceLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.passDialog = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.form,
        "label-width": "100px"
      }
    }, [_c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "发票地址",
        "prop": "invoice_img"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入发票地址"
      },
      model: {
        value: (_vm.form.invoice_img),
        callback: function($$v) {
          _vm.$set(_vm.form, "invoice_img", $$v)
        },
        expression: "form.invoice_img"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "用户ID",
        "prop": "user_id"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入用户ID"
      },
      model: {
        value: (_vm.form.user_id),
        callback: function($$v) {
          _vm.$set(_vm.form, "user_id", $$v)
        },
        expression: "form.user_id"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "订单号",
        "prop": "channelOrderNo"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入订单号"
      },
      model: {
        value: (_vm.form.channelOrderNo),
        callback: function($$v) {
          _vm.$set(_vm.form, "channelOrderNo", $$v)
        },
        expression: "form.channelOrderNo"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "处方单",
        "prop": "drug"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入处方单地址"
      },
      model: {
        value: (_vm.form.drug),
        callback: function($$v) {
          _vm.$set(_vm.form, "drug", $$v)
        },
        expression: "form.drug"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "身份证正面地址",
        "prop": "front"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输身份证入正面地址"
      },
      model: {
        value: (_vm.form.front),
        callback: function($$v) {
          _vm.$set(_vm.form, "front", $$v)
        },
        expression: "form.front"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "身份证反面地址",
        "prop": "backend"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入身份证反面地址"
      },
      model: {
        value: (_vm.form.backend),
        callback: function($$v) {
          _vm.$set(_vm.form, "backend", $$v)
        },
        expression: "form.backend"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-center"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.saveInvoice
      }
    }, [_vm._v("确定保存")])], 1)], 1)]
  ], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5eff10e2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5eff10e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/baoxian/zhongan/order.vue
// module id = 2757
// module chunks = 0